/**
 * spec-hydrator: params から仕様テキスト(specText)/全体仕様(fullSpec)を生成する。
 *
 * poc_test_designer 側の「ターゲット同期」で使われていた params→specText 導出ロジックを
 * インポート時に TTM 側で実行し、生成結果を value.poc.specText として永続化するための入口。
 * 出力は poc_test_designer の hydrate と一致させる（移植元と等価に保つ）。
 */
import {
  build_target_display_name_resolver,
  hydrate_spec_text_from_params,
  type HydratedSpecText,
  type TargetNameLookupRow,
} from "./hydrate-spec-text";
import { normalizeItemCategoryParams } from "./item-category";

export type { HydratedSpecText, TargetNameLookupRow } from "./hydrate-spec-text";

export interface GenerateSpecTextInput {
  targetType?: string | null;
  name: string;
  description?: string | null;
  params?: unknown;
  /** 画面遷移の targetId を名称へ解決するための参照テーブル（任意） */
  targetNameLookup?: TargetNameLookupRow[];
}

/**
 * targetType + params から specText / fullSpec を生成する（DB は更新しない）。
 * item は itemCategories を正規化してから hydrate する（poc_test_designer と同一手順）。
 */
export function generateSpecTextFromParams(
  target: GenerateSpecTextInput
): HydratedSpecText {
  let params = target.params;
  if (
    target.targetType?.toLowerCase() === "item" &&
    params !== undefined &&
    params !== null
  ) {
    params = normalizeItemCategoryParams(params);
  }

  const resolveTargetDisplayName = target.targetNameLookup
    ? build_target_display_name_resolver(target.targetNameLookup)
    : undefined;

  return hydrate_spec_text_from_params({
    targetType: target.targetType ?? undefined,
    name: target.name,
    description: target.description ?? null,
    params: params ?? null,
    resolveTargetDisplayName,
  });
}
